import { Button, Empty, Typography } from 'antd';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextUsers } from '../../../../../context/users';
import { usePlanId, useSubscriptionId } from '../../../../../hooks/stripe';
import ContentCard from '../../../../Common/ContentCard';
import { formatPlanData } from '../../../../Common/PlansDetails/PlanItem';
import useTrialDaysLeft from '../../../../../hooks/useTrialDaysLeft';
import styles from './index.module.less';

const CurrentPlan = () => {
  const navigate = useNavigate();
  const trialDaysLeft = useTrialDaysLeft();
  const { profile } = useContextUsers();
  const planId = usePlanId();
  const subscriptionId = useSubscriptionId();

  const subscription = subscriptionId?.data?.data;

  const [endDate, setEndDate] = useState<string>();

  useEffect(() => {
    if (profile?.planId) {
      planId.fetch(undefined, profile.planId);
    }

    if (profile?.subscriptionId) {
      subscriptionId.fetch(undefined, profile.subscriptionId).then((response) => {
        if (!response?.data) return;

        const { current_period_start, current_period_end, plan, cancel_at } = response.data;

        if (cancel_at) {
          setEndDate(moment.unix(cancel_at).format('MMM DD, YYYY'));
        } else if (plan?.trial_period_days) {
          setEndDate(moment.unix(current_period_start).add(plan?.trial_period_days, 'days').format('MMM DD, YYYY'));
        } else {
          setEndDate(moment.unix(current_period_end).format('MMM DD, YYYY'));
        }
      });
    }
  }, [profile]);

  const handleUpdatePlan = () => {
    if (profile?.planId) {
      navigate('/plans');
    } else {
      navigate('/setup');
    }
  };

  return (
    <ContentCard
      loading={planId.loading || subscriptionId.loading}
      bordered
      padding={20}
      height="100%"
      footer={
        <Button type="primary" size="large" onClick={handleUpdatePlan}>
          {profile?.planId ?
            `Change to ${planId?.data?.data?.interval === 'year' ? 'Monthly' : 'Yearly'} Plan` : 'Secure Access'}
        </Button>
      }
    >
      {profile?.planId ? (
        <div className={styles.content}>
          <div className={styles.textRow}>
            <div>
              <Typography.Title level={3}>
                {planId.data?.data?.nickname} {!!trialDaysLeft && `(${trialDaysLeft} days left)`}
              </Typography.Title>
              {endDate && (
                <Typography className="color-gray">
                  {subscription?.cancel_at ? 'Cancels' : 'Next renewal'} on {endDate}
                </Typography>
              )}
            </div>
            {planId.data?.data.amount && planId.data.data.interval && (
              <Typography.Title className={styles.price}>{formatPlanData(planId.data.data)}</Typography.Title>
            )}
          </div>
        </div>
      ) : (
        <Empty
          style={{ margin: 0, flex: '1 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <>
              <div>No active plan</div>
              {!!trialDaysLeft && (
                <div style={{ marginTop: 8, color: '#595959' }}>
                  <p style={{ marginBottom: '4px' }}>
                    Your free trial ends in {trialDaysLeft} day{trialDaysLeft !== 1 ? 's' : ''}.
                  </p>
                  <p>Add your payment method now to avoid any interruption in access.</p>
                </div>
              )}
            </>
          }
        />
      )}
    </ContentCard>
  );
};

export default CurrentPlan;
